<script setup lang="ts">
const locale = await getLocale("ko", "request_pending");

defineComponent({
    name: "RequestPending"
});

const emit = defineEmits(["init"])

onMounted(() => {
    emit("init")
})

</script>
<template>
    <div class="mx-auto lg:container text-sm sm:text-base leading-tight text-gray-700 py-4">
        <div class="flex items-center justify-center z-10 top-24 sm:top-0">
            <div class="bg-white p-4 mx-4 text-center rounded-3xl mb-64 max-w-xl text-gray-700 shadow-xl">
                <i class="icon lens block mx-auto"></i>
                <h1 class="text-3xl sm:text-3xl font-semibold md:w-2/3 mx-auto mt-4">{{ locale.title }}</h1>
                <p class="my-6">{{ locale.message1 }}<strong>{{ locale.message2 }}</strong>.</p>
                <p class="my-6"><strong>{{ locale.alert }}</strong></p>
            </div>
        </div>
    </div>
</template>